<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <textarea
      :id="id"
      :value="modelValue"
      :disabled="disabled"
      :placeholder="placeholder"
      :rows="rows"
      class="w-full"
      :class="{
        'p-invalid': validation?.$error || modelstate,
      }"
      :aria-describedby="`${id}-help`"
      @input="handleInput"
      @paste="handlePaste"
    ></textarea>
    <span v-if="modelstate" class="p-error">
      {{ modelstate }}
    </span>
    <span
      v-if="
        validation?.$error &&
        validation.required &&
        validation.required.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.required.$message.replace("Value", PropName) }}
    </span>
    <span
      v-else-if="
        validation?.$error &&
        validation.requiredIf &&
        validation.requiredIf.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.requiredIf.$message.replace("value", PropName) }}
    </span>
    <span
      v-else-if="
        validation?.$error && validation.email && validation.email.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.email.$message }}
    </span>
    <span
      v-else-if="
        validation?.$error && validation.min && validation.min.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.min.$message }}
    </span>
    <span
      v-else-if="
        validation?.$error && validation.max && validation.max.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.max.$message }}
    </span>
    <span
      v-else-if="
        validation?.$error && validation.minLength && validation.minLength.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.minLength.$message }}
    </span>
    <span
      v-else-if="
        validation?.$error && validation.maxLength && validation.maxLength.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.maxLength.$message }}
    </span>
    <span
      v-else-if="
        validation?.$error && validation.sameAs && validation.sameAs.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.sameAs.$message }}
    </span>
    <span
      v-else-if="
        validation?.$error && validation.numeric && validation.numeric.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.numeric.$message }}
    </span>
    <span
      v-else-if="
        validation?.$error && validation.isValidLandingURL && validation.isValidLandingURL.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      The specified condition was not met for 'URL'.
    </span>
    <span
      v-else-if="!validation?.isValidLandingURL && IsLandingURL && validation.required"
      class="invalid-feedback"
    >
      The specified condition was not met for 'URL'.
    </span>
    <span
      v-else-if="!validation?.isValidLandingURL && IsLandingURL"
      class="invalid-feedback"
    >
      The specified condition was not met for 'URL'.
    </span>
    <span
      v-else-if="
        validation?.$error && validation.isValidCustomCss && validation.isValidCustomCss.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      The value must start with '#' or '.'
    </span>
    <span
      v-else-if="
        validation?.$error && validation.isValidImageUrl && validation.isValidImageUrl.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      The value must start with 'http://' or 'https://'.
    </span>
  </div>
</template>

<script>
import { sanitizeInput } from "@/utils/sanitize";

export default {
  props: {
    PropName: {
      type: String,
      default: "",
    },
    validation: {
      type: Object,
      required: false,
    },
    modelstate: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    maxlength: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    IsLandingURL: {
      type: Boolean,
      default: false,
    },
    IsCustomFieldForRule: {
      type: Boolean,
      default: false,
    },
    IsCustomTagForRule: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 4,
    },
  },
  methods: {
    handleInput(event) {
      const rawValue = event.target.value;
      // Remove dangerous tags like <script> but keep < character and safe HTML
      const sanitizedValue = sanitizeInput(rawValue);
      this.$emit("update:modelValue", sanitizedValue);
    },
    handlePaste(event) {
      event.preventDefault();
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');
      const sanitizedText = sanitizeInput(pastedText);
      const currentValue = event.target.value;
      const start = event.target.selectionStart;
      const end = event.target.selectionEnd;
      const newValue = currentValue.substring(0, start) + sanitizedText + currentValue.substring(end);
      this.$emit("update:modelValue", newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
// input{
//     color: #21211f !important;
//     font-size: 16px;
//     width: 100%;
//     resize: none;
//     box-shadow: none;
//     border-radius: 0.25rem;
//     font-weight: 500;
//     line-height: 1;
//     font-family: "voyado Text";
//     padding: 10px;
// }

textarea:enabled:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}

textarea {
  color: #21211f !important;
  font-size: 16px;
  width: 100%;
  box-shadow: none;
  font-weight: 500;
  line-height: 1.5;
  font-family: "voyado Text";
  padding: 11px 10px 10px 10px;
  align-items: flex-start;
  align-self: stretch;
  flex: 1 0 0;
  height: 153px;
  resize: none;
  // border-radius: 10px;
  border-radius: 0.25rem;
  border: 1px solid #C0C0BC;
  background: #FFF;
}

.p-error {
  color: #dc3545;
  font-size: 0.875rem;
  display: block;
}

.invalid-feedback {
  color: #dc3545;
  font-size: 0.875rem;
  display: block;
  margin-top: 0.25rem;
}
</style>